import React from 'react';
import { Search, Filter, X } from 'lucide-react';
import { Input } from '../ui/input';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { Card, CardContent } from '../ui/card';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../ui/select';

export interface LocationFilters {
  search: string;
}

interface FilterPanelProps {
  filters: LocationFilters;
  onFiltersChange: (filters: LocationFilters) => void;
  resultCount: number;
}

export const FilterPanel: React.FC<FilterPanelProps> = ({
  filters,
  onFiltersChange,
  resultCount,
}) => {
  const handleSearchChange = (value: string) => {
    onFiltersChange({ ...filters, search: value });
  };

  const clearFilters = () => {
    onFiltersChange({
      search: '',
    });
  };

  const hasActiveFilters = !!filters.search;

  const getActiveFiltersCount = () => {
    return filters.search ? 1 : 0;
  };

  return (
    <Card>
      <CardContent className="pt-6">
        <div className="space-y-4">
          {/* Строка поиска */}
          <div className="flex gap-4">
            <div className="relative flex-1">
              <Search className="absolute left-3 top-3 h-4 w-4 text-muted-foreground" />
              <Input
                placeholder="Поиск по названию или адресу..."
                value={filters.search}
                onChange={(e) => handleSearchChange(e.target.value)}
                className="pl-10"
              />
            </div>
            {hasActiveFilters && (
              <Button
                variant="outline"
                onClick={clearFilters}
                className="gap-2"
              >
                <X className="h-4 w-4" />
                Очистить
              </Button>
            )}
          </div>

          {/* Фильтры удалены по запросу */}
          
          {/* Результаты */}
          <div className="flex justify-between items-center text-sm text-muted-foreground">
            <span>
              Найдено локаций: <strong>{resultCount}</strong>
            </span>
            {hasActiveFilters && (
              <div className="flex gap-2">
                {filters.search && (
                  <Badge variant="outline">
                    Поиск: "{filters.search}"
                  </Badge>
                )}
              </div>
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};